import { XMarkIcon } from '@heroicons/react/24/outline';
import { useFormContext, useWatch } from 'react-hook-form';
import { useShallow } from 'zustand/react/shallow';

import { IconButton } from '@/components/core/IconButton';

import { useValidationsStore } from '../hooks/useValidationsStore';

interface ClearButtonProps {
    attributeName: string;
    fieldPath: string;
}

const ClearButton = ({ attributeName, fieldPath }: ClearButtonProps) => {

    const { setValue, trigger } = useFormContext();
    const fieldValue = useWatch({ name: fieldPath });
    const isEmptyValue = fieldValue === undefined
        || fieldValue === null
        || fieldValue === ''
        || (Array.isArray(fieldValue) && fieldValue.length === 0);

    const { removeErrorByPath, removeWarningByPath, removeLocalValidationError } = useValidationsStore(
        useShallow(state => ({
            removeErrorByPath: state.removeErrorByPath,
            removeWarningByPath: state.removeWarningByPath,
            removeLocalValidationError: state.removeLocalValidationError,
        }))
    );

    const clear = () => {
        if (isEmptyValue) {
            return;
        }
        removeErrorByPath(fieldPath);
        removeWarningByPath(fieldPath);
        removeLocalValidationError(fieldPath);

        setValue(fieldPath, '', { shouldDirty: true });
        trigger(fieldPath);
    };

    return (
        <IconButton
            id={`${attributeName}_clear`}
            className="tw-absolute tw-ml-2"
            type="button"
            size='md'
            variant='destructive'
            icon={XMarkIcon}
            onClick={()=> clear()}
            aria-label="Clear value"
            disabled={isEmptyValue}
        />
    );
};

ClearButton.DisplayName = 'ClearButton';

export { ClearButton };
